import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  colorDimensions: [],
  insideColorDimensions: [],
  dimensionsWithSelectableValues: [],
  publishLevel: 100,
};

const dimensionsSlice = createSlice({
  name: "dimensions",
  initialState,
  reducers: {
    setColorDimensions(state, action) {
      state.colorDimensions = action.payload;
    },
    setInsideColorDimensions(state, action) {
      state.insideColorDimensions = action.payload;
    },
    setDimensionsWithSelectableValues(state, action) {
      state.dimensionsWithSelectableValues = action.payload;
    },
    setPublishLevel(state, action) {
      state.publishLevel = action.payload;
    }
  },
});

export const { setColorDimensions, setInsideColorDimensions, setDimensionsWithSelectableValues, setPublishLevel } = dimensionsSlice.actions;

export default dimensionsSlice.reducer;
